import { useState } from "react";
import { Sparkles, Send, RotateCcw, Loader2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { ChatBubble } from "@/lib/aiChat";
import { useAiChat } from "@/hooks/useAiChat";

const SUGGESTIONS = ["Summarise treasury balances", "Any suspicious sign-ins lately?", "How much fee income so far?", "How healthy was the RPC today?"];

export const AdminAssistant = () => {
  const [input, setInput] = useState("");
  const { messages, busy, error, send, reset, endRef } = useAiChat({
    path: "/admin/assistant/chat", historyPath: "/admin/assistant/sessions", storageKey: "fsc_admin_ai_session",
  });
  const submit = (text) => { setInput(""); send(text); };

  return (
    <Card data-testid="admin-assistant" className="border-[#D4AF37]/30 bg-[#0A0A0A]">
      <CardHeader className="pb-3 flex flex-row items-center justify-between space-y-0">
        <CardTitle className="text-base font-display flex items-center gap-2"><Sparkles size={16} className="text-[#D4AF37]" /> AI Assistant <span className="text-[10px] text-zinc-500 font-normal">GPT 6 Sol · live data</span></CardTitle>
        <Button data-testid="assistant-new-chat-btn" variant="ghost" size="sm" onClick={reset} disabled={busy} className="text-zinc-400"><RotateCcw size={14} className="mr-1.5" /> New chat</Button>
      </CardHeader>
      <CardContent className="space-y-3">
        <div data-testid="assistant-messages" className="space-y-3 max-h-[420px] min-h-[120px] overflow-y-auto pr-1">
          {messages.length === 0 && (
            <div className="flex flex-wrap gap-2">
              {SUGGESTIONS.map((s) => (
                <button key={s} data-testid="assistant-suggestion" onClick={() => submit(s)}
                  className="text-xs px-3 py-1.5 rounded-full border border-[#2A2411] text-zinc-300 hover:border-[#D4AF37]/60 hover:text-white transition-colors">{s}</button>
              ))}
            </div>
          )}
          {messages.map((m) => <ChatBubble key={m.id} m={m} />)}
          <div ref={endRef} />
        </div>
        {error && <p data-testid="assistant-error" className="text-sm text-red-400">{error}</p>}
        <form onSubmit={(e) => { e.preventDefault(); submit(input); }} className="flex gap-2 items-end">
          <Textarea data-testid="assistant-input" rows={2} value={input} onChange={(e) => setInput(e.target.value)} maxLength={4000}
            onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(input); } }}
            placeholder="Ask about balances, fees, sign-ins or uptime…" className="bg-[#050505] border-[#2A2411] text-white resize-none" />
          <Button data-testid="assistant-send-btn" type="submit" disabled={busy || !input.trim()} className="bg-[#D4AF37] text-black hover:bg-[#F3E5AB] h-[60px] w-[60px]">
            {busy ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
          </Button>
        </form>
        <p className="text-[11px] text-zinc-600">Read-only: the assistant can explain data but never moves funds. Answers can be wrong; double-check before acting.</p>
      </CardContent>
    </Card>
  );
};
